import { createContext, useContext } from 'react';
const initialValue = {
  paymentsEligibility: undefined
};
export const PaymentsEligibilityContext = /*#__PURE__*/createContext(initialValue);
export function usePaymentsEligibilityContext() {
  return useContext(PaymentsEligibilityContext);
}